import React from 'react'

const getFieldCSSClasses = (touched: any, errors: any) => {
  const classes = ['form-control']
  /*if (touched && errors) {
    classes.push('is-invalid')
  }

  if (touched && !errors) {
    classes.push('is-valid')
  }*/

  return classes.join(' ')
}

const handleAlphaOnlyKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
  const allowedKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'ArrowLeft',
    'ArrowRight',
    'Home',
    'End',
    'Enter',
  ]
  if (!allowedKeys.includes(e.key) && !/^[A-Za-z\s]$/.test(e.key) && !e.ctrlKey && !e.metaKey) {
    e.preventDefault()
  }
}

const handleAlphaOnlyPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
  const paste = e.clipboardData.getData('text')
  if (!/^[A-Za-z\s]*$/.test(paste)) {
    e.preventDefault()
  }
}

const isNameField = (name: string | undefined) => {
  if (!name) return false
  const fieldName = name.split('.').pop() || ''
  return fieldName === 'first_name' || fieldName === 'last_name'
}

export function Input({
  field, // { name, value, onChange, onBlur }
  form: {touched, errors}, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  type = 'text',
  extraText,
  ...props
}: any) {
  const nameField = isNameField(field.name)
  return (
    <>
      {label && <label className={extraText && 'mb-0'}>Enter {label}</label>}
      {extraText && <p className='text-muted font-weight-light'>{extraText}</p>}
      <input
        type={type}
        className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        {...field}
        {...props}
        {...(nameField ? {onKeyDown: handleAlphaOnlyKeyDown, onPaste: handleAlphaOnlyPaste} : {})}
      />
    </>
  )
}
